import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

const COLORS = ["#4fc3f7", "#3fb950", "#d2a8ff", "#ffa657", "#f85149"];

export default function LineChartWidget({ title, data, labels, unit, color = "#4fc3f7", datasets: datasetsProp }) {
  const builtDatasets = Array.isArray(datasetsProp) && datasetsProp.length > 0
    ? datasetsProp.map((ds, i) => ({
        label: ds.label || title,
        data: ds.data || [],
        borderColor: COLORS[i % COLORS.length],
        backgroundColor: `${COLORS[i % COLORS.length]}33`,
        borderWidth: 2,
        fill: true,
        tension: 0.4,
        pointRadius: 0,
        pointHoverRadius: 4,
      }))
    : [
        {
          label: title,
          data: data || generateMockData(12),
          borderColor: color,
          backgroundColor: `${color}33`,
          borderWidth: 2,
          fill: true,
          tension: 0.4,
          pointRadius: 0,
          pointHoverRadius: 4,
        },
      ];

  const chartData = {
    labels: labels || generateTimeLabels(builtDatasets[0]?.data?.length || 12),
    datasets: builtDatasets,
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: { bottom: 6 },
    },
    plugins: {
      legend: { display: builtDatasets.length > 1 },
      tooltip: {
        backgroundColor: "#161b22",
        titleColor: "#8b949e",
        bodyColor: "#fff",
        borderColor: "#30363d",
        borderWidth: 1,
        callbacks: {
          label: (ctx) => `${ctx.parsed.y} ${unit || ""}`,
        },
      },
    },
    scales: {
      x: {
        grid: { color: "#21262d", drawBorder: false },
        ticks: { color: "#8b949e", font: { size: 10 }, maxRotation: 0 },
      },
      y: {
        grid: { color: "#21262d", drawBorder: false },
        ticks: {
          color: "#8b949e",
          font: { size: 10 },
          callback: (val) => `${val}${unit ? ` ${unit}` : ""}`,
        },
      },
    },
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <span style={styles.title}>{title}</span>
      </div>
      <div style={styles.chartWrapper}>
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}

function generateTimeLabels(count) {
  const labels = [];
  const now = new Date();
  for (let i = count - 1; i >= 0; i--) {
    const time = new Date(now - i * 5 * 60 * 1000);
    labels.push(time.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }));
  }
  return labels;
}

function generateMockData(count) {
  return Array.from({ length: count }, () => Math.random() * 50 + 25);
}

const styles = {
  container: {
    backgroundColor: "#161b22",
    borderRadius: "8px",
    padding: "8px 10px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    marginBottom: "4px",
  },
  title: {
    color: "#e6edf3",
    fontSize: "12px",
    fontWeight: "500",
  },
  chartWrapper: {
    flex: 1,
    minHeight: 0,
  },
};
